module.exports = __webpack_public_path__ + "static/media/097-san-marino.e322e7de.svg";